import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Check, Users, Heart, GraduationCap, Building2, Stethoscope, Brain, MessageCircle } from "lucide-react";

// ============ IMAGES FROM AWAREHUB WEBSITE ONLY ============
const IMAGES = {
  logo: "https://awarehub.com.au/wp-content/uploads/awarehub-logo-transparent-003.png",
  logoWhite: "https://awarehub.com.au/wp-content/uploads/awarehub-logo-transparent-for-use-on-dark-background-002.png",
  drLisa: "https://awarehub.com.au/wp-content/uploads/lisa.jpg",
  drLisaDirector: "https://awarehub.com.au/wp-content/uploads/Dr-Lisa-Myers-AwareHub-Director-and-Psychiatrist--e1732146069656.jpg",
  tmsNurse: "https://awarehub.com.au/wp-content/uploads/Senior-TMS-Nurse-Aashna-Lal-performing-TMS-Service_web.jpg",
  reception: "https://awarehub.com.au/wp-content/uploads/reception-area-2-2-1024x683.jpg",
  dva: "https://awarehub.com.au/wp-content/uploads/DVA-Logo.png",
  medicare: "https://awarehub.com.au/wp-content/uploads/Logo-Medicare-transparent.png",
  ndis: "https://awarehub.com.au/wp-content/uploads/NDIS-logo.png",
};

// ============ SHARED NAVIGATION ============
const Navigation = () => (
  <nav className="w-full fixed top-0 left-0 right-0 z-50" data-testid="careers-navigation">
    <div className="bg-[#6BACA9] py-2 px-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <p className="text-white text-sm font-medium tracking-wide">AWAREHUB BUNDABERG TMS NOW OPEN!</p>
        <div className="flex items-center gap-3">
          <a href="https://www.facebook.com/awarehubclinic" target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"><Facebook className="w-4 h-4 text-white" /></a>
          <a href="https://www.instagram.com/awarehub_clinic/" target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"><Instagram className="w-4 h-4 text-white" /></a>
          <a href="https://www.linkedin.com/in/lisa-myers-psychiatrist/" target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"><Linkedin className="w-4 h-4 text-white" /></a>
        </div>
      </div>
    </div>
    <div className="bg-white shadow-lg py-3 px-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2" data-testid="logo"><img src={IMAGES.logo} alt="AwareHub Logo" className="h-12" /></div>
          <Link to="/tms" className="text-[#6BACA9] hover:text-[#5D9E9B] font-semibold text-sm transition-colors">New TMS</Link>
          <Link to="/accelerated-tms" className="text-[#6BACA9] hover:text-[#5D9E9B] font-semibold text-sm transition-colors">Accelerated TMS</Link>
          <Link to="/esketamine" className="text-[#6BACA9] hover:text-[#5D9E9B] font-semibold text-sm transition-colors">New Esketamine</Link>
          <Link to="/careers" className="text-[#6BACA9] hover:text-[#5D9E9B] font-semibold text-sm transition-colors">Careers</Link>
        </div>
        <div className="flex items-center gap-4">
          <a href="tel:1300029273" className="hidden md:flex items-center gap-2 text-slate-700 hover:text-[#6BACA9] transition-colors">
            <div className="w-10 h-10 rounded-full bg-[#6BACA9]/10 flex items-center justify-center"><Phone className="w-5 h-5 text-[#6BACA9]" /></div>
            <div><p className="text-xs text-slate-500">Call us now</p><p className="font-bold text-sm">1300 029 273</p></div>
          </a>
          <a href="mailto:reception@awarehub.com.au" className="bg-[#6BACA9] hover:bg-[#5D9E9B] text-white px-6 py-3 rounded-md font-semibold text-sm">CONTACT US</a>
        </div>
      </div>
    </div>
  </nav>
);

// ============ SHARED FOOTER ============
const Footer = () => (
  <footer className="bg-[#1e293b] text-white py-16">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid md:grid-cols-4 gap-12">
        <div>
          <img src={IMAGES.logoWhite} alt="AwareHub" className="h-12 mb-6" />
          <div className="space-y-3 text-slate-400 text-sm">
            <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-1 text-[#7DBDBA]" /><span>Suite 703/ 1 Newland Street, Bondi Junction, NSW 2022</span></div>
            <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-1 text-[#7DBDBA]" /><span>The Friendlies Medical Suites, 70-72 Crofton Street, Bundaberg QLD, 4670</span></div>
            <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#7DBDBA]" /><a href="tel:1300029273" className="hover:text-[#7DBDBA]">1300-0-AWARE (29273)</a></div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#7DBDBA]" /><a href="mailto:reception@awarehub.com.au" className="hover:text-[#7DBDBA]">reception@awarehub.com.au</a></div>
          </div>
        </div>
        <div><h4 className="font-bold mb-4">Menu</h4><ul className="space-y-2 text-slate-400 text-sm">{["Home","About","Services","TMS","Careers"].map(l=><li key={l}><a href="#" className="hover:text-[#7DBDBA]">{l}</a></li>)}</ul></div>
        <div><h4 className="font-bold mb-4">Our Services</h4><ul className="space-y-2 text-slate-400 text-sm">{["Psychiatry","Psychology","NDIS","TMS Treatment","Esketamine"].map(l=><li key={l}><a href="#" className="hover:text-[#7DBDBA]">{l}</a></li>)}</ul></div>
        <div><h4 className="font-bold mb-4">Connect With Us</h4><div className="flex gap-3">
          <a href="https://www.facebook.com/awarehubclinic" className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-[#6BACA9]"><Facebook className="w-5 h-5" /></a>
          <a href="https://www.instagram.com/awarehub_clinic/" className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-[#6BACA9]"><Instagram className="w-5 h-5" /></a>
          <a href="https://www.linkedin.com/in/lisa-myers-psychiatrist/" className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-[#6BACA9]"><Linkedin className="w-5 h-5" /></a>
        </div></div>
      </div>
      <div className="border-t border-slate-700 mt-12 pt-8 text-center text-slate-500 text-sm">
        <p>AwareHub acknowledges and pays respect to the past, present and future Traditional Custodians and Elders of this nation and the continuation of cultural, spiritual and educational practices of Aboriginal and Torres Strait Islander peoples.</p>
      </div>
    </div>
  </footer>
);

// ============ VERSION A: MAGAZINE EDITORIAL STYLE ============
const VersionA = () => (
  <div className="version-a pt-28">
    {/* JOIN OUR TEAM */}
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h1 className="text-4xl font-bold text-[#6BACA9] mb-4">JOIN OUR TEAM AT AWAREHUB</h1>
        <p className="text-2xl font-semibold text-slate-700 mb-2">SHAPE THE FUTURE OF INTEGRATED MENTAL HEALTH</p>
        <p className="text-2xl font-semibold text-slate-700">PRACTICE CLINICALLY WITH COMPLETE SUPPORT</p>
      </div>
    </section>

    {/* Intro with Image */}
    <section className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-slate-600 leading-relaxed text-lg">At AwareHub, we don't practice in isolation. We continue to build a truly collaborative, multidisciplinary ecosystem where psychiatrists, medical specialists, GPs, and allied health professionals work side by side. Whether you are an established clinician looking to transition to a modern metro/telehealth practice, or an early-career doctor seeking robust clinical supervision and mentorship, we handle the friction. We provide the support, tools, and community you need to focus purely on clinical excellence while delivering vital care in Sydney and regional areas, including Bundaberg, QLD.</p>
          </div>
          <div><img src={IMAGES.reception} alt="AwareHub Reception" className="rounded-2xl shadow-2xl w-full" /></div>
        </div>
      </div>
    </section>

    {/* LOCATION HUBS */}
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-slate-900 mb-8">LOCATION HUBS AND TARGET SPECIALISATIONS</h2>
        
        {/* Sydney Metro Hub */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-[#6BACA9] mb-4">Sydney Metro Hub & National Telehealth (Based in Bondi Junction, Sydney, NSW / Hybrid)</h3>
          <p className="text-slate-600 mb-6">We are looking to expand our specialised consulting team with clinicians who want to focus on their specific areas of care, supported by state-of-the-art clinic infrastructure and structured peer support.</p>
          
          <div className="bg-slate-50 rounded-xl p-6 mb-6">
            <h4 className="font-bold text-slate-900 mb-4">Psychiatrists (Special Interests):</h4>
            <p className="text-slate-600 mb-4">We are seeking Consultant Psychiatrists (including newly qualified Fellows looking for a supportive transition to private practice) who want to build a dedicated focus on:</p>
            <ul className="space-y-2 text-slate-700">
              <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#6BACA9]" /><span>Child & Adolescent Psychiatry</span></li>
              <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#6BACA9]" /><span>Addiction Medicine</span></li>
              <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#6BACA9]" /><span>Neuromodulation Treatments (TMS/Esketamine)</span></li>
              <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#6BACA9]" /><span>General adult psychiatry</span></li>
            </ul>
          </div>
          
          <div className="bg-slate-50 rounded-xl p-6">
            <h4 className="font-bold text-slate-900 mb-4">Complementary Medical Specialists & GPs:</h4>
            <p className="text-slate-600 mb-4">To enrich our holistic diagnostic and treatment capabilities, we invite applications from:</p>
            <ul className="space-y-2 text-slate-700">
              <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#6BACA9]" /><span>General Practitioners (With keen interests in Mental Health)</span></li>
              <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#6BACA9]" /><span>Paediatricians (General & Developmental)</span></li>
              <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#6BACA9]" /><span>Neurologists & Geriatricians</span></li>
              <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#6BACA9]" /><span>Nurse Practitioners (Mental Health)</span></li>
            </ul>
          </div>
        </div>

        {/* Regional Hub */}
        <div>
          <h3 className="text-2xl font-bold text-[#6BACA9] mb-4">Regional Hub & Multi-Disciplinary Health (Bundaberg Clinic)</h3>
          <p className="text-slate-600 mb-6">Help us bridge the regional healthcare gap in a high-growth, welcoming community. Our Bundaberg hub offers an incredibly rewarding clinical environment with an endless stream of referrals, an on-site TMS suite, Esketamine and an integrated local healthcare network.</p>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-slate-50 rounded-xl p-6">
              <h4 className="font-bold text-slate-900 mb-4">General Practitioners & Specialists:</h4>
              <p className="text-slate-600">Practice clinically, with the help of excellent administrative and peer support. Hybrid options available.</p>
            </div>
            <div className="bg-slate-50 rounded-xl p-6">
              <h4 className="font-bold text-slate-900 mb-4">Allied Health Team:</h4>
              <p className="text-slate-600 mb-4">We are actively building our regional multi-disciplinary team and want to hear from both experienced and early-career:</p>
              <ul className="space-y-2 text-slate-700 text-sm">
                <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Psychologists & Clinical Psychologists</span></li>
                <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Occupational Therapists (OT)</span></li>
                <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Speech Pathologists & Dietitians</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* SUPPORT FOR NEW GRADUATES */}
    <section className="py-16 bg-[#6BACA9]">
      <div className="max-w-4xl mx-auto px-6 text-white">
        <h2 className="text-3xl font-bold mb-4">SUPPORT FOR NEW GRADUATES AND EARLY-CAREER DOCTORS</h2>
        <h3 className="text-xl font-semibold mb-6">🚀 Launching Your Career with AwareHub</h3>
        <p className="text-white/90 mb-8">Starting in private practice can feel daunting. At AwareHub, new graduates and early-career doctors are welcomed and well-supported by our experienced administrative and clinical teams:</p>
        
        <ul className="space-y-6">
          <li className="flex items-start gap-4">
            <Check className="w-6 h-6 mt-0.5 flex-shrink-0" />
            <div><strong>Formal Clinical Mentorship:</strong> Work alongside senior consultants and specialised psychiatrists who are passionate about teaching and case-sharing.</div>
          </li>
          <li className="flex items-start gap-4">
            <Check className="w-6 h-6 mt-0.5 flex-shrink-0" />
            <div><strong>Active Peer Review Groups:</strong> Participate in regular, formal internal peer review groups to discuss complex presentations, share insights, and meet your college CPD requirements.</div>
          </li>
          <li className="flex items-start gap-4">
            <Check className="w-6 h-6 mt-0.5 flex-shrink-0" />
            <div><strong>A Ready-Made Multi-Disciplinary Network:</strong> Learn faster by collaborating daily with an in-house team of psychologists, psychiatrists, neuropsychologists, OTs, Speech Therapists and dieticians. You'll always have a colleague under the same roof to cross-consult with.</div>
          </li>
          <li className="flex items-start gap-4">
            <Check className="w-6 h-6 mt-0.5 flex-shrink-0" />
            <div><strong>Graduated Caseloads:</strong> We don't overwhelm you on day one. We manage your intake carefully, matching you with appropriate patient profiles as you build up your clinical confidence and pacing.</div>
          </li>
        </ul>
      </div>
    </section>

    {/* Let's Have a Chat */}
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div><img src={IMAGES.drLisaDirector} alt="Dr Lisa Myers" className="rounded-2xl shadow-xl w-full" /></div>
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Let's Have a Confidential Chat</h2>
            <p className="text-slate-600 leading-relaxed mb-6">We know that changing or launching a medical practice is a significant milestone. Whether you are an experienced specialist or a recent graduate seeking to learn more about our clinic and structures, please email us at <a href="mailto:reception@awarehub.com.au" className="text-[#6BACA9] font-semibold hover:underline">reception@awarehub.com.au</a> to arrange a confidential discussion with our clinical management team.</p>
            <a href="mailto:reception@awarehub.com.au" className="inline-flex items-center gap-2 bg-[#6BACA9] text-white px-8 py-4 rounded-xl font-semibold hover:bg-[#5D9E9B] transition-colors">
              <Mail className="w-5 h-5" /> Contact Us Today
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);

// ============ VERSION B: CLINICAL TWO-COLUMN STYLE ============
const VersionB = () => (
  <div className="version-b pt-28">
    {/* JOIN OUR TEAM */}
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h1 className="text-3xl font-bold text-[#6BACA9] mb-4">JOIN OUR TEAM AT AWAREHUB</h1>
          <p className="text-xl font-semibold text-slate-700 mb-2">SHAPE THE FUTURE OF INTEGRATED MENTAL HEALTH</p>
          <p className="text-xl font-semibold text-slate-700 mb-6">PRACTICE CLINICALLY WITH COMPLETE SUPPORT</p>
          <p className="text-slate-600 leading-relaxed">At AwareHub, we don't practice in isolation. We continue to build a truly collaborative, multidisciplinary ecosystem where psychiatrists, medical specialists, GPs, and allied health professionals work side by side. Whether you are an established clinician looking to transition to a modern metro/telehealth practice, or an early-career doctor seeking robust clinical supervision and mentorship, we handle the friction. We provide the support, tools, and community you need to focus purely on clinical excellence while delivering vital care in Sydney and regional areas, including Bundaberg, QLD.</p>
        </div>
        <div><img src={IMAGES.tmsNurse} alt="TMS Nurse" className="rounded-xl shadow-lg" /></div>
      </div>
    </section>

    {/* LOCATION HUBS - Side by Side */}
    <section className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-slate-900 mb-8 text-center">LOCATION HUBS AND TARGET SPECIALISATIONS</h2>
        
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Sydney */}
          <div className="bg-white rounded-2xl p-8 shadow-md">
            <div className="flex items-center gap-3 mb-4">
              <Building2 className="w-8 h-8 text-[#6BACA9]" />
              <h3 className="text-xl font-bold text-[#6BACA9]">Sydney Metro Hub & National Telehealth</h3>
            </div>
            <p className="text-slate-500 text-sm mb-4">(Based in Bondi Junction, Sydney, NSW / Hybrid)</p>
            <p className="text-slate-600 mb-6 text-sm">We are looking to expand our specialised consulting team with clinicians who want to focus on their specific areas of care, supported by state-of-the-art clinic infrastructure and structured peer support.</p>
            
            <h4 className="font-bold text-slate-900 mb-3 text-sm">Psychiatrists (Special Interests):</h4>
            <p className="text-slate-600 mb-3 text-xs">We are seeking Consultant Psychiatrists (including newly qualified Fellows looking for a supportive transition to private practice) who want to build a dedicated focus on:</p>
            <ul className="space-y-1 text-slate-700 text-sm mb-6">
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Child & Adolescent Psychiatry</span></li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Addiction Medicine</span></li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Neuromodulation Treatments (TMS/Esketamine)</span></li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>General adult psychiatry</span></li>
            </ul>
            
            <h4 className="font-bold text-slate-900 mb-3 text-sm">Complementary Medical Specialists & GPs:</h4>
            <p className="text-slate-600 mb-3 text-xs">To enrich our holistic diagnostic and treatment capabilities, we invite applications from:</p>
            <ul className="space-y-1 text-slate-700 text-sm">
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>General Practitioners (With keen interests in Mental Health)</span></li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Paediatricians (General & Developmental)</span></li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Neurologists & Geriatricians</span></li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#6BACA9]" /><span>Nurse Practitioners (Mental Health)</span></li>
            </ul>
          </div>

          {/* Bundaberg */}
          <div className="bg-[#6BACA9] rounded-2xl p-8 text-white">
            <div className="flex items-center gap-3 mb-4">
              <Heart className="w-8 h-8" />
              <h3 className="text-xl font-bold">Regional Hub & Multi-Disciplinary Health</h3>
            </div>
            <p className="text-white/70 text-sm mb-4">(Bundaberg Clinic)</p>
            <p className="text-white/90 mb-6 text-sm">Help us bridge the regional healthcare gap in a high-growth, welcoming community. Our Bundaberg hub offers an incredibly rewarding clinical environment with an endless stream of referrals, an on-site TMS suite, Esketamine and an integrated local healthcare network.</p>
            
            <h4 className="font-bold mb-3 text-sm">General Practitioners & Specialists:</h4>
            <p className="text-white/80 mb-6 text-sm">Practice clinically, with the help of excellent administrative and peer support. Hybrid options available.</p>
            
            <h4 className="font-bold mb-3 text-sm">Allied Health Team:</h4>
            <p className="text-white/80 mb-3 text-xs">We are actively building our regional multi-disciplinary team and want to hear from both experienced and early-career:</p>
            <ul className="space-y-1 text-sm">
              <li className="flex items-center gap-2"><Check className="w-4 h-4" /><span>Psychologists & Clinical Psychologists</span></li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4" /><span>Occupational Therapists (OT)</span></li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4" /><span>Speech Pathologists & Dietitians</span></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    {/* SUPPORT FOR NEW GRADUATES */}
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-slate-900 mb-2">SUPPORT FOR NEW GRADUATES AND EARLY-CAREER DOCTORS</h2>
        <h3 className="text-lg font-semibold text-[#6BACA9] mb-6">🚀 Launching Your Career with AwareHub</h3>
        <p className="text-slate-600 mb-8">Starting in private practice can feel daunting. At AwareHub, new graduates and early-career doctors are welcomed and well-supported by our experienced administrative and clinical teams:</p>
        
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-slate-50 rounded-xl p-6">
            <GraduationCap className="w-8 h-8 text-[#6BACA9] mb-3" />
            <h4 className="font-bold text-slate-900 mb-2">Formal Clinical Mentorship:</h4>
            <p className="text-slate-600 text-sm">Work alongside senior consultants and specialised psychiatrists who are passionate about teaching and case-sharing.</p>
          </div>
          <div className="bg-slate-50 rounded-xl p-6">
            <Users className="w-8 h-8 text-[#6BACA9] mb-3" />
            <h4 className="font-bold text-slate-900 mb-2">Active Peer Review Groups:</h4>
            <p className="text-slate-600 text-sm">Participate in regular, formal internal peer review groups to discuss complex presentations, share insights, and meet your college CPD requirements.</p>
          </div>
          <div className="bg-slate-50 rounded-xl p-6">
            <Brain className="w-8 h-8 text-[#6BACA9] mb-3" />
            <h4 className="font-bold text-slate-900 mb-2">A Ready-Made Multi-Disciplinary Network:</h4>
            <p className="text-slate-600 text-sm">Learn faster by collaborating daily with an in-house team of psychologists, psychiatrists, neuropsychologists, OTs, Speech Therapists and dieticians. You'll always have a colleague under the same roof to cross-consult with.</p>
          </div>
          <div className="bg-slate-50 rounded-xl p-6">
            <Stethoscope className="w-8 h-8 text-[#6BACA9] mb-3" />
            <h4 className="font-bold text-slate-900 mb-2">Graduated Caseloads:</h4>
            <p className="text-slate-600 text-sm">We don't overwhelm you on day one. We manage your intake carefully, matching you with appropriate patient profiles as you build up your clinical confidence and pacing.</p>
          </div>
        </div>
      </div>
    </section>

    {/* Let's Have a Chat */}
    <section className="py-16 bg-slate-900 text-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <MessageCircle className="w-12 h-12 mx-auto mb-4 text-[#7DBDBA]" />
        <h2 className="text-2xl font-bold mb-4">Let's Have a Confidential Chat</h2>
        <p className="text-slate-300 mb-8">We know that changing or launching a medical practice is a significant milestone. Whether you are an experienced specialist or a recent graduate seeking to learn more about our clinic and structures, please email us at <a href="mailto:reception@awarehub.com.au" className="text-[#7DBDBA] font-semibold hover:underline">reception@awarehub.com.au</a> to arrange a confidential discussion with our clinical management team.</p>
        <a href="mailto:reception@awarehub.com.au" className="inline-flex items-center gap-2 bg-[#6BACA9] text-white px-8 py-4 rounded-xl font-semibold hover:bg-[#5D9E9B] transition-colors">
          <Mail className="w-5 h-5" /> Contact Us Today
        </a>
      </div>
    </section>
  </div>
);

// ============ VERSION C: BOLD VISUAL STYLE ============
const VersionC = () => (
  <div className="version-c pt-28">
    {/* JOIN OUR TEAM - Full Width Hero */}
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-5xl lg:text-6xl font-bold text-[#6BACA9] mb-6">JOIN OUR TEAM AT AWAREHUB</h1>
        <p className="text-2xl font-semibold text-slate-700 mb-2">SHAPE THE FUTURE OF INTEGRATED MENTAL HEALTH</p>
        <p className="text-2xl font-semibold text-slate-700">PRACTICE CLINICALLY WITH COMPLETE SUPPORT</p>
      </div>
    </section>

    {/* Intro - Split */}
    <section className="py-0">
      <div className="grid lg:grid-cols-2">
        <div className="h-[500px]"><img src={IMAGES.drLisaDirector} alt="Dr Lisa Myers" className="w-full h-full object-cover" /></div>
        <div className="bg-[#6BACA9] p-12 lg:p-16 flex flex-col justify-center">
          <p className="text-white/90 leading-relaxed text-lg">At AwareHub, we don't practice in isolation. We continue to build a truly collaborative, multidisciplinary ecosystem where psychiatrists, medical specialists, GPs, and allied health professionals work side by side. Whether you are an established clinician looking to transition to a modern metro/telehealth practice, or an early-career doctor seeking robust clinical supervision and mentorship, we handle the friction. We provide the support, tools, and community you need to focus purely on clinical excellence while delivering vital care in Sydney and regional areas, including Bundaberg, QLD.</p>
        </div>
      </div>
    </section>

    {/* LOCATION HUBS */}
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-slate-900 mb-12 text-center">LOCATION HUBS AND TARGET SPECIALISATIONS</h2>
        
        {/* Sydney Metro Hub */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-[#6BACA9] mb-4">Sydney Metro Hub & National Telehealth</h3>
          <p className="text-slate-500 mb-4">(Based in Bondi Junction, Sydney, NSW / Hybrid)</p>
          <p className="text-lg text-slate-600 mb-8">We are looking to expand our specialised consulting team with clinicians who want to focus on their specific areas of care, supported by state-of-the-art clinic infrastructure and structured peer support.</p>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-bold text-slate-900 text-xl mb-4">Psychiatrists (Special Interests):</h4>
              <p className="text-slate-600 mb-4">We are seeking Consultant Psychiatrists (including newly qualified Fellows looking for a supportive transition to private practice) who want to build a dedicated focus on:</p>
              <ul className="space-y-3 text-slate-700">
                <li className="flex items-center gap-3"><Check className="w-6 h-6 text-[#6BACA9]" /><span>Child & Adolescent Psychiatry</span></li>
                <li className="flex items-center gap-3"><Check className="w-6 h-6 text-[#6BACA9]" /><span>Addiction Medicine</span></li>
                <li className="flex items-center gap-3"><Check className="w-6 h-6 text-[#6BACA9]" /><span>Neuromodulation Treatments (TMS/Esketamine)</span></li>
                <li className="flex items-center gap-3"><Check className="w-6 h-6 text-[#6BACA9]" /><span>General adult psychiatry</span></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-slate-900 text-xl mb-4">Complementary Medical Specialists & GPs:</h4>
              <p className="text-slate-600 mb-4">To enrich our holistic diagnostic and treatment capabilities, we invite applications from:</p>
              <ul className="space-y-3 text-slate-700">
                <li className="flex items-center gap-3"><Check className="w-6 h-6 text-[#6BACA9]" /><span>General Practitioners (With keen interests in Mental Health)</span></li>
                <li className="flex items-center gap-3"><Check className="w-6 h-6 text-[#6BACA9]" /><span>Paediatricians (General & Developmental)</span></li>
                <li className="flex items-center gap-3"><Check className="w-6 h-6 text-[#6BACA9]" /><span>Neurologists & Geriatricians</span></li>
                <li className="flex items-center gap-3"><Check className="w-6 h-6 text-[#6BACA9]" /><span>Nurse Practitioners (Mental Health)</span></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Regional Hub */}
        <div className="bg-slate-900 rounded-3xl p-12 text-white">
          <h3 className="text-3xl font-bold mb-4">Regional Hub & Multi-Disciplinary Health (Bundaberg Clinic)</h3>
          <p className="text-white/90 text-lg mb-8">Help us bridge the regional healthcare gap in a high-growth, welcoming community. Our Bundaberg hub offers an incredibly rewarding clinical environment with an endless stream of referrals, an on-site TMS suite, Esketamine and an integrated local healthcare network.</p>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-bold text-xl mb-4">General Practitioners & Specialists:</h4>
              <p className="text-white/80">Practice clinically, with the help of excellent administrative and peer support. Hybrid options available.</p>
            </div>
            <div>
              <h4 className="font-bold text-xl mb-4">Allied Health Team:</h4>
              <p className="text-white/80 mb-4">We are actively building our regional multi-disciplinary team and want to hear from both experienced and early-career:</p>
              <ul className="space-y-2">
                <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#7DBDBA]" /><span>Psychologists & Clinical Psychologists</span></li>
                <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#7DBDBA]" /><span>Occupational Therapists (OT)</span></li>
                <li className="flex items-center gap-2"><Check className="w-5 h-5 text-[#7DBDBA]" /><span>Speech Pathologists & Dietitians</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* SUPPORT FOR NEW GRADUATES */}
    <section className="py-20 bg-slate-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-slate-900 mb-4">SUPPORT FOR NEW GRADUATES AND EARLY-CAREER DOCTORS</h2>
        <h3 className="text-2xl font-semibold text-[#6BACA9] mb-8">🚀 Launching Your Career with AwareHub</h3>
        <p className="text-lg text-slate-600 mb-12">Starting in private practice can feel daunting. At AwareHub, new graduates and early-career doctors are welcomed and well-supported by our experienced administrative and clinical teams:</p>
        
        <div className="space-y-8">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-[#6BACA9] rounded-2xl flex items-center justify-center flex-shrink-0"><GraduationCap className="w-8 h-8 text-white" /></div>
            <div>
              <h4 className="font-bold text-slate-900 text-xl mb-2">Formal Clinical Mentorship:</h4>
              <p className="text-slate-600 text-lg">Work alongside senior consultants and specialised psychiatrists who are passionate about teaching and case-sharing.</p>
            </div>
          </div>
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-[#6BACA9] rounded-2xl flex items-center justify-center flex-shrink-0"><Users className="w-8 h-8 text-white" /></div>
            <div>
              <h4 className="font-bold text-slate-900 text-xl mb-2">Active Peer Review Groups:</h4>
              <p className="text-slate-600 text-lg">Participate in regular, formal internal peer review groups to discuss complex presentations, share insights, and meet your college CPD requirements.</p>
            </div>
          </div>
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-[#6BACA9] rounded-2xl flex items-center justify-center flex-shrink-0"><Brain className="w-8 h-8 text-white" /></div>
            <div>
              <h4 className="font-bold text-slate-900 text-xl mb-2">A Ready-Made Multi-Disciplinary Network:</h4>
              <p className="text-slate-600 text-lg">Learn faster by collaborating daily with an in-house team of psychologists, psychiatrists, neuropsychologists, OTs, Speech Therapists and dieticians. You'll always have a colleague under the same roof to cross-consult with.</p>
            </div>
          </div>
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-[#6BACA9] rounded-2xl flex items-center justify-center flex-shrink-0"><Stethoscope className="w-8 h-8 text-white" /></div>
            <div>
              <h4 className="font-bold text-slate-900 text-xl mb-2">Graduated Caseloads:</h4>
              <p className="text-slate-600 text-lg">We don't overwhelm you on day one. We manage your intake carefully, matching you with appropriate patient profiles as you build up your clinical confidence and pacing.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Let's Have a Chat - Split */}
    <section className="py-0">
      <div className="grid lg:grid-cols-2">
        <div className="bg-[#6BACA9] p-12 lg:p-16 flex flex-col justify-center">
          <h2 className="text-4xl font-bold text-white mb-6">Let's Have a Confidential Chat</h2>
          <p className="text-white/90 text-lg leading-relaxed mb-8">We know that changing or launching a medical practice is a significant milestone. Whether you are an experienced specialist or a recent graduate seeking to learn more about our clinic and structures, please email us at <a href="mailto:reception@awarehub.com.au" className="text-white font-bold underline">reception@awarehub.com.au</a> to arrange a confidential discussion with our clinical management team.</p>
          <a href="mailto:reception@awarehub.com.au" className="inline-flex items-center gap-2 bg-white text-[#6BACA9] px-8 py-4 rounded-xl font-semibold hover:bg-slate-100 transition-colors w-fit">
            <Mail className="w-5 h-5" /> Contact Us Today
          </a>
        </div>
        <div className="h-[500px]"><img src={IMAGES.tmsNurse} alt="TMS Nurse" className="w-full h-full object-cover" /></div>
      </div>
    </section>
  </div>
);

// ============ MAIN CAREERS PAGE COMPONENT ============
const CareersPage = () => {
  const [selectedVersion, setSelectedVersion] = useState("A");
  const versions = { 
    A: { name: "Magazine", component: VersionA, color: "bg-orange-500 hover:bg-orange-600", activeColor: "bg-orange-600" }, 
    B: { name: "Clinical", component: VersionB, color: "bg-purple-500 hover:bg-purple-600", activeColor: "bg-purple-600" }, 
    C: { name: "Bold", component: VersionC, color: "bg-blue-500 hover:bg-blue-600", activeColor: "bg-blue-600" } 
  };
  const SelectedComponent = versions[selectedVersion].component;

  return (
    <div className="min-h-screen bg-white" data-testid="careers-page">
      <Navigation />
      <div className="fixed top-32 right-4 z-40 md:top-28 md:right-6" data-testid="version-selector">
        <div className="bg-white rounded-xl shadow-2xl border border-slate-200 p-3">
          <label className="block text-xs font-bold text-slate-600 mb-2 text-center">DESIGN VERSION</label>
          <div className="flex gap-2">
            {Object.entries(versions).map(([key, val]) => (
              <button 
                key={key} 
                onClick={() => setSelectedVersion(key)} 
                className={`px-4 py-2 rounded-lg font-bold text-white text-sm transition-all ${selectedVersion === key ? val.activeColor + ' ring-2 ring-offset-2 ring-slate-400 scale-105' : val.color}`}
              >
                {key}
              </button>
            ))}
          </div>
        </div>
      </div>
      <SelectedComponent />
      <Footer />
    </div>
  );
};

export default CareersPage;
